import React from 'react';
import PropTypes from 'prop-types';
import { trans } from '@spotahome/soyuz-trans/client';

import FooterBlockTitle from './components/FooterBlockTitle';
import FooterBlockList from './components/FooterBlockList';
import FooterLink from './components/FooterLink';

const LandlordFooter = props => {
  const landlordLinks = [
    {
      url: props.publishYourProperty,
      locoKey: 'footer.item.publish_your_property'
    },
    {
      url: props.help,
      locoKey: 'footer.item.help'
    },
    {
      url: props.contactUs,
      locoKey: 'footer.item.contact_us'
    }
  ];

  return (
    <React.Fragment>
      <FooterBlockTitle text={trans('footer.label.landlords')} />
      <FooterBlockList>
        {landlordLinks.map(({ locoKey, url }) => (
          <FooterLink key={locoKey} linkTheme={props.linkTheme} href={url}>
            {trans(locoKey)}
          </FooterLink>
        ))}
      </FooterBlockList>
    </React.Fragment>
  );
};

LandlordFooter.propTypes = {
  publishYourProperty: PropTypes.string.isRequired,
  help: PropTypes.string.isRequired,
  contactUs: PropTypes.string.isRequired,
  linkTheme: PropTypes.string.isRequired
};

export default LandlordFooter;
